// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Lock = React.forwardRef(function Lock(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Lock" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 10H6V7.5C6 4.18629 8.68629 1.5 12 1.5C15.3137 1.5 18 4.18629 18 7.5V10H20V22H4V10ZM15 7.5V10H9V7.5C9 5.84315 10.3431 4.5 12 4.5C13.6569 4.5 15 5.84315 15 7.5ZM12 14.25C10.7574 14.25 9.75 15.2574 9.75 16.5C9.75 17.7426 10.7574 18.75 12 18.75C13.2426 18.75 14.25 17.7426 14.25 16.5C14.25 15.2574 13.2426 14.25 12 14.25Z", fill: "currentColor" }))));
});
Lock.displayName = 'Lock';
export default Lock;
//# sourceMappingURL=Lock.js.map